import { useQuestionnaireNavigation } from '@/context/NavigationProvider';
import BlignyLogo from '@/assets/BlignyLogo.svg';
import { LandingPageFooter } from '@/pages/onboarding/LandingPageFooter';
import { PatientPageLayout } from '@/components/PatientPageLayout';

interface AccueilPageProps {
  onNext?: () => void;
}

export const AccueilPage = ({ onNext }: AccueilPageProps) => {
  const { navigateNext } = useQuestionnaireNavigation();

  const handleStartQuestionnaire = () => {
    if (onNext) {
      onNext();
    } else {
      navigateNext();
    }
  };

  return (
    <PatientPageLayout
      title={
        <div className="flex flex-col items-center gap-4">
          <img src={BlignyLogo} alt="Bligny Logo" className="w-37" />
          <p className="text-1.5xl text-center font-medium">
            Questionnaire Sommeil
          </p>
        </div>
      }
      titleClassName="text-center"
      contentClassName="flex flex-col items-center justify-center text-center"
      footer={
        <div className="w-full flex flex-col items-center justify-center">
          <LandingPageFooter
            consultationDuration={20}
            buttonLabel="Commencer"
            onClick={handleStartQuestionnaire}
          />
        </div>
      }
    >
      <p className="text-center text-sm font-light leading-5 px-2">
        Madame, Monsieur, <br /> <br /> Dans le cadre de l&apos;amélioration
        continue de la qualité des soins et du parcours patient, le Centre
        Hospitalier de Bligny a mis en place un{' '}
        <span className="font-semibold">
          questionnaire de pré-consultation en ligne
        </span>
        , via le dispositif Aldebaran,{' '}
        <span className="font-semibold">
          à compléter avant votre première venue.
        </span>{' '}
        <br /> <br /> Ce questionnaire permet de recueillir les informations
        nécessaires à la préparation de votre consultation, afin d&apos;aider le
        médecin à{' '}
        <span className="font-semibold">
          mieux comprendre vos symptômes et à organiser votre parcours de soins.
        </span>
      </p>
    </PatientPageLayout>
  );
};
